import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'action-plan',
    templateUrl: './action-plan.component.html',
    styleUrls: ['./action-plan.component.css']
})
export class UnitTwoLessonSevenActionPlanComponent {

    title: string = "Action Plan";
    pageTitle: string = this.title + " | Unit 2, Lesson 7 | T-Folio";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }

}
